import FreespinsMediator from "mediators/freespins-mediator";
import { JumpstartSpinCommand } from "slotworks/commands/comms/jumpstart-spin-command";
import HidePromoFSonFreespins from "slotworks/commands/promo-free-spins/hide-pfs-on-freespins";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import translations from "slotworks/i18n/translations";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import EnterRecoveryFreespins from "slotworks/state-machine/standard/states/enter-recovery-freespins";
import { parallel } from "slotworks/utils/race-utils";
import HarleyComponents from "components/components";
import HarleyFreespinRecord from "integration/records/freespin-record";
import soundManager from "slotworks/sound/sound-manager";

export default class HarleyEnterRecoveryFreespins extends EnterRecoveryFreespins {

    public onEnter() {
        regulation.interactionStart();
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as HarleyFreespinRecord;

        // Increase remaining free spins and take away any won on this spin to simulate what count would be on previous result (which we don't have)
        const actualFreespins = record.remainingFreespins;
        record.remainingFreespins++;
        record.remainingFreespins -= record.freespinsWon;

        // if campaing is active we change the way smart button works to regular freespins
        HidePromoFSonFreespins();

        HarleyComponents.bonusBuyButton.hide();
        
        // Update smart button count
        smartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);

        Components.betBar.setBetOptions(betModel.generateBetOptions());
        Components.betBar.setType(BetBarType.FREESPINS);
        new FreespinsMediator().start().execute();

        // Reset back to correct free spin count
        record.remainingFreespins = actualFreespins;

        Components.betBar.winnings.setWinnings(0, gameplay.getRunningFreespinsWinTotal() - gameplay.getCurrentRecord().creditsWon);
        this.homeButton = Layers.BetBar.getFlexiButton("home");
        this.homeURL = settingsModel.homeURL;
        if (this.homeButton) {
            if (this.homeURL === "close" || this.homeURL === "" || this.homeURL === undefined || this.homeURL === null) {
                this.homeButton.setVisible(false);
            } else {
                this.homeButton.setVisible(true);
            }
        }
        Components.betBar.setEnabled(false);
        this.recoverFreespinsElements();
        // HarleyComponents.background.start();
        const boosters = (gameState.getCurrentGame().records[0] as HarleyFreespinRecord).giftedAdditional || 0;
        if(boosters) {
            HarleyComponents.messages.setFreespins(boosters);
            HarleyComponents.quickHit.restoreFreespinsBoosts(boosters);
        }

        soundManager.customEvent("freespins_music");

        const contents = new Map<string, string>();
        contents.set("body", translations.get("rec.fre"));

        parallel([
            () => JumpstartSpinCommand(), 
            () => Components.prompt.show(["info", "error"], contents)
        ]).then(() => this.complete());
    }
}